import template from './ordenes-detalle.html';
import iniciarTemplate from './iniciar.html';
import agregarTemplate from './agregar.html';
import terminarTemplate from './terminar.html';
import viewAtributosTemplate from './view-atributos.html';
import nuevoAtributoClienteTemplate from './atributo-cliente.nuevo.html';
import { FormActions } from 'core/services/form';
import ordenesI18N from 'i18n/ordenes/es.json';
import { horaRenderer, fechaHoraRenderer, sortAdicionalesServicio, fullscreen } from 'core/util';
import { rest } from 'core/api';

import { compare } from 'core/util';

export let OrdenesComponent = {
  templateUrl: template,
  selector: 'ordenesDetalle',
  bindings: {
    translations: '='
  },
  controller: OrdenesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(ordenesI18N).concat(commonsI18N);

OrdenesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'ConfirmationModal', '$stateParams', 'CustomModal', '$filter', '$timeout', '$scope', '$q'
];

function OrdenesCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, ConfirmationModal, $stateParams, CustomModal, $filter, $timeout, $scope, $q) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder;
  var staticFilter;
  let columns = [
    { data: 'id', title: 'Id' },
    { data: 'codigo', title: this.translations['Código'] },
    { data: 'orden.cliente.razonSocial', title: this.translations['Cliente'] },
    { data: 'especialista.nombre', title: this.translations['Nombre Especialista'] },
    { data: 'especialista.apellido', title: this.translations['Apellido Especialista'] },
    { data: 'servicio.nombre', title: this.translations['Servicio'] },
    { data: 'fechaCita', title: this.translations['Fecha Cita/Turno'], renderWith: fechaHoraRenderer, type: 'date-range' },
    { data: 'fechaInicio', title: this.translations['Hora Inicio'], renderWith: horaRenderer, type: 'date-range' },
    { data: 'estadoDetalle.value', title: this.translations['Estado'] }
  ];

  let columnsProducto = [
    { data: 'id', title: 'Id' },
    { data: 'codigo', title: this.translations['Código'] },
    { data: 'cantidad', title: this.translations['Cantidad'] },
    {
      data: 'especialista.nombre',
      title: this.translations['Nombre Especialista'],
      defaultContent: '<i>N/A</i>'
    },
    { data: 'especialista.apellido', title: this.translations['Apellido Especialista'], defaultContent: '<i>N/A</i>' },
    { data: 'producto.nombre', title: this.translations['Producto'] }
  ];

  if ($stateParams.eid) {
    this.especialista = true;
    staticFilter = Filter.path('especialista.id').eq($stateParams.eid);

    defaultColumnOrder = ['codigo', 'orden.cliente.razonSocial', 'servicio.nombre', 'fechaCita', 'fechaInicio', 'estadoDetalle.value'];
  } else if ($stateParams.cid) {
    this.cliente = true;
    staticFilter = Filter.path('cabecera.cliente.id').eq($stateParams.cid);

    defaultColumnOrder = ['codigo', 'especialista.nombre', 'especialista.apellido', 'servicio.nombre', 'fechaCita', 'fechaInicio', 'estadoDetalle.value'];
  }

  BasicFactory.setup('ordenes');

  // const estadoQuery = Filter.path('tipo.codigo').eq('estado_orden_trabajo');
  // const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));
  this.localModel = {
    payload: {},
    terminar: {}
  };

  this.optionsProducto = {
    resource: 'ordenes-de-trabajo-detalles-producto',
    hideHeader: true,
    hasOptions: true,
    // detailRows: [
    //   { data: 'codigo', title: this.translations['Código'] },
    //   { data: 'servicio.nombre', title: this.translations['Servicio'] }
    // ],
    dom: 'rtip',
    drawCallback: function(oSettings) {
      if (oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
        $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
      }
    },
    title: this.translations['Listado de productos en ordenes'],
    factory: BasicFactory,
    defaultColumnOrder: ['codigo', 'cantidad', 'especialista.nombre', 'especialista.apellido', 'producto.nombre'],
    columns: columnsProducto,
    defaultOrderColumn: 1,
    defaultOrderDir: 'desc',
    onRemove: onRemove.bind(this),
    canListCondition: () => { false; },
    canEditCondition: () => { false; }
  };

  function onRemove(itemId) {
    this.remove('ordenes-de-trabajo-detalles-producto', itemId);
  }

  this.options = {
    resource: 'ordenes-de-trabajo-detalles',
    hideHeader: true,
    hasOptions: true,
    // detailRows: [
    //   { data: 'codigo', title: this.translations['Código'] },
    //   { data: 'servicio.nombre', title: this.translations['Servicio'] }
    // ],
    dom: 'rtip',
    drawCallback: function(oSettings) {
      if (oSettings._iDisplayLength >= oSettings.fnRecordsDisplay()) {
        $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
      }
    },
    title: this.translations['Listado de ordenes'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns,
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    canListCondition: () => { false; },
    canEditCondition: () => { false; },
    canRemoveCondition: () => { false; },
    canIniciar: canIniciar.bind(this),
    canTerminar: canTerminar.bind(this),
    canAsignar: canAsignar.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable-big btn btn-warning btn-dt" uib-tooltip="' + this.translations['Asignar'] + '" ng-show="options.canAsignar(rowsData[<%= dataId %>])" ng-click="asignarDetalle(rowsData[<%= dataId %>])"> <span class="">Asignar</span></button>',
        functionName: 'asignarDetalle',
        functionDef: (item) => {
          let self = this;
          this.localModel.payload = {};
          let options = {
            title: 'Re-Asignar',
            item: item,
            vm: self,
            seleccionar: true,
            templateUrl: iniciarTemplate,
            empleado: this.model,
            mostrarCodigo: true,
            payload: this.localModel.payload,
            messageClass: 'font-large',
            headerClass: 'font-large',
            ok: function() {
              options.scope.$$childHead.formAsignar.especialista.$setTouched();
              if (!self.localModel.payload.especialista) {
                return false;
              }

              options.scope.$$childHead.formPin.pin.$setTouched();
              if (!self.localModel.payload.pin) {
                return false;
              }

              options.scope.$$childHead.formPin.codigo.$setTouched();
              if (!self.localModel.payload.codigoAutorizacion) {
                return false;
              }


              let payload = {
                codigoAutorizacion: self.localModel.payload.codigoAutorizacion,
                empleadoId: self.localModel.payload.especialista.id,
                pin: self.localModel.payload.pin
              };

              $ngRedux.dispatch(rest.actions.actualizarEspecialistaDetalle({ id: item.id }, {
                body: JSON.stringify(payload)
              }, (err, data) => {
                if (!err) {
                  ngNotify.set(self.translations['Reasignada Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          };
          CustomModal.open(options);
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable-big btn btn-primary btn-dt" uib-tooltip="' + this.translations['Iniciar'] + '" ng-show="options.canIniciar(rowsData[<%= dataId %>])" ng-click="iniciarDetalle(rowsData[<%= dataId %>])"> <span class="">Iniciar</span></button>',
        functionName: 'iniciarDetalle',
        functionDef: (item) => {
          let self = this;
          this.localModel.payload = {};
          self.localModel.modalOptions = {
            title: 'Iniciar',
            item: item,
            templateUrl: iniciarTemplate,
            empleado: this.model,
            payload: this.localModel.payload,
            messageClass: 'font-large',
            headerClass: 'font-large',
            ok: function() {
              $ngRedux.dispatch(rest.actions.iniciarDetalle({ id: item.id }, {
                body: JSON.stringify(self.localModel.payload)
              }, (err, data) => {
                if (!err && data.estadoDetalle.value === 'En proceso') {
                  ngNotify.set(self.translations['Iniciada Correctamente'], 'success');
                  self.options.reloadData();
                  self.localModel.modalOptions.scope.cancel();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
              return false;
            }
          };

          CustomModal.open(self.localModel.modalOptions);
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable-big btn btn-danger btn-dt" uib-tooltip="' + this.translations['Terminar'] + '" ng-show="options.canTerminar(rowsData[<%= dataId %>])" ng-click="terminarDetalle(rowsData[<%= dataId %>])"> <span class="">Terminar</span></button>',
        functionName: 'terminarDetalle',
        functionDef: (item) => {
          let self = this;
          this.localModel.payload = {
            adicionales: {},
            usoInsumo: {}
          };


          mapDetallesTerminar(item.servicio).then(function(value) {
            let { list, obligatorios, adicionales } = value;

            self.localModel.terminar = {
              itemPadre: item,
              openProducto: true,
              nuevoDetalleProducto: { cantidad : 1, categoria: item.servicio.conProductoCategoria },
              listProductos: [],
              servicio: item.servicio,
              list,
              obligatorios,
              adicionales
            };

            function updateCantidadMostrada(detalle) {
              detalle.cantidadMostrada = detalle.uso.cantidadDosisMinima + ((detalle.cantidad - 1) * detalle.uso.dosisAdicional);
            }

            self.localModel.atributos = null;

            self.localModel.modalOptions = {
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
              vm: self,
              title: 'Terminar',
              terminar: self.localModel.terminar,
              templateUrl: terminarTemplate,
              empleado: self.model,
              clearSearch: function(modal) {
                self.localModel.search = null;
              },
              payload: self.localModel.payload,
              payloadAtributo: {cliente: self.localModel.terminar.itemPadre.orden.cliente},
              selectUsoInsumo: (detalle, index) => {
                self.localModel.payload.usados = {};
                self.localModel.payload.usoInsumo[detalle.id].forEach((element) => {
                  self.localModel.payload.usados[element.uso.id] = true;
                });
                self.localModel.payload.usoInsumo[detalle.id][index].cantidad = 1;
                updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
              },
              filterUso: (uso) => {
                return self.localModel.payload.usados ? !self.localModel.payload.usados[uso.id] : true;
              },
              toggleUtilizar: (detalle) => {  
              if (self.confirmarAdicionales) {
                  CustomModal.open({
                    title: 'Confirmar Adicional',
                    message:'¿Esta seguro que desea agregar/eliminar el adicional?',
                    payload: self.localModel.payload,
                    ok: function() {
                      if( self.localModel.payload.adicionales[detalle.id] == true){
                        self.localModel.payload.adicionales[detalle.id] = true;
                      }else{
                        self.localModel.payload.adicionales[detalle.id] = false;
                      }
  
                      if (detalle.adicional && detalle.adicional.controlStock) {
                       self.localModel.payload.usoInsumo[detalle.id] = [{ cantidad: 1 }];
                      }
                    }
                  });
                } else {
                    if( self.localModel.payload.adicionales[detalle.id] == true){
                      self.localModel.payload.adicionales[detalle.id] = true;
                    }else{
                      self.localModel.payload.adicionales[detalle.id] = false;
                    }

                    if (detalle.adicional && detalle.adicional.controlStock) {
                     self.localModel.payload.usoInsumo[detalle.id] = [{ cantidad: 1 }];
                    }
                  }
              },
              toggleDown: function(detalle, index) {
                if (self.localModel.payload.usoInsumo[detalle.id][index].cantidad > 0) {
                  self.localModel.payload.usoInsumo[detalle.id][index].cantidad--;
                  updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
                }
              },
              toggleUp: function(detalle, index) {
                self.localModel.payload.usoInsumo[detalle.id][index].cantidad++;
                updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
              },
              addUsoInsumo: function(detalle) {
                self.localModel.payload.usoInsumo[detalle.id].push({ cantidad: 1 });
              },
              removeUsoInsumo: function(detalle, index) {
                self.localModel.payload.usoInsumo[detalle.id].splice(index, 1);
              },
              newDetalleProducto: function() {
                if (!self.localModel.terminar.nuevoDetalleProducto.producto) {
                  ngNotify.set(`Debe seleccionar un producto`, 'warn');
                  return;
                }
                if (!self.localModel.terminar.nuevoDetalleProducto.cantidad || self.localModel.terminar.nuevoDetalleProducto.cantidad<1) {
                  ngNotify.set(`La cantidad minima debe ser uno`, 'warn');
                  return;
                }
                self.localModel.terminar.listProductos.push(self.localModel.terminar.nuevoDetalleProducto);
                self.localModel.terminar.nuevoDetalleProducto = { cantidad : 1, categoria: self.localModel.terminar.servicio.conProductoCategoria };
              },
              removeDetalleProducto: function(index) {
                self.localModel.terminar.listProductos.splice(index, 1);
              },
              loadUsosInsumo: function(query, detalle) {
                let filter = Filter.path('estado.value').eq('Activo').and(Filter.path('producto.id').eq(detalle.adicional.id));
                if (query) {
                  filter = filter.and(Filter.path('codigo').like(query));
                }
                BasicFactory.setup('usos-insumo');
                return BasicFactory.all({ filter: JSON.stringify(filter) });
              },
              renderUsoInsumo: function(item) {
                let info = ` - Stock: ${item.cantidad - item.cantidadUtilizada}`;

                if (item.producto.unidadMedida) {
                  info += ` (${item.producto.unidadMedida.nombre})`;
                }

                return `${item.codigo}${info}`;
              },
              messageClass: 'font-large',
              headerClass: 'font-large',
              ok: function() {
                let payload = {};
                payload.pin = self.localModel.payload.pin;
                payload.adicionales = Object.keys(self.localModel.payload.adicionales)
                  .filter(v => self.localModel.payload.adicionales[v]).map((e, index) => {
                    return {
                      id: e,
                      adicionalId: self.localModel.terminar.adicionales[e].adicional ? self.localModel.terminar.adicionales[e].adicional.id : null,
                      tipoAdicionalId: self.localModel.terminar.adicionales[e].tipoProductoAdicional.id
                    };
                  });


                let faltan = [];
                Object.keys(self.localModel.terminar.obligatorios).forEach(function(key) {
                  let marcados = Object.keys(self.localModel.payload.adicionales).filter(v => self.localModel.terminar.adicionales[v].tipoProductoAdicional.adicional.id == key);

                  if (!marcados.length) {
                    faltan.push(self.localModel.terminar.obligatorios[key].nombre);
                  }
                });

                if (faltan.length) {
                  ngNotify.set(`Debe indicar tipo adicional: ${faltan.join(' - ')}`, 'warn');
                  return false;
                }
                payload.usoInsumo = {};
                faltan = [];
                payload.adicionales.forEach(function(element) {
                  let key = element.id;
                  if (self.localModel.payload.usoInsumo[key]) {
                    self.localModel.payload.usoInsumo[key].forEach(function(usoDetalle) {
                      if (!usoDetalle.uso) {
                        faltan.push(self.localModel.terminar.adicionales[key].adicional.nombre);
                        return;
                      }
                      payload.usoInsumo[key] = payload.usoInsumo[key] || [];
                      payload.usoInsumo[key].push({
                        cantidad: usoDetalle.cantidad,
                        cantidadDosis: usoDetalle.cantidadMostrada,
                        usoInsumoId: usoDetalle.uso.id
                      });
                    });
                  }
                });

                if (faltan.length) {
                  ngNotify.set(`Debe indicar el Insumo Usado: ${faltan.join(' - ')}`, 'warn');
                  return false;
                }

                if (self.localModel.terminar.itemPadre.servicio.id !== self.localModel.terminar.servicio.id) {
                  payload.servicioHijoId = self.localModel.terminar.servicio.id;
                }

                if (self.localModel.terminar.servicio.conProducto) {
                  payload.productos = [];
                  self.localModel.terminar.listProductos.forEach(p => {
                    payload.productos.push({
                      cantidad: p.cantidad,
                      productoId: p.producto.id
                    });
                  });
                }

                $ngRedux.dispatch(rest.actions.terminarDetalle({ id: item.id }, {
                  body: JSON.stringify(payload)
                }, (err, data) => {
                  if (!err && data.estadoDetalle.value === 'Finalizado') {
                    ngNotify.set(self.translations['Terminada Correctamente'], 'success');
                    self.options.reloadData();
                    self.localModel.modalOptions.scope.cancel();
                  } else if (err) {
                    ngNotify.set(err.message, 'warn');
                  }
                }));
                return false;
              }
            };

            CustomModal.open(self.localModel.modalOptions);
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable-big btn btn-dt" style="margin-left: 6px; min-width: 60px;" uib-tooltip="' + this.translations['Atributos'] + '" ng-show="true" ng-click="viewAtributos(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-typicons-tag"></span></button>',
        functionName: 'viewAtributos',
        functionDef: (item) => {
          let self = this;
          // Eliminar la hora de las fechas
          (item.orden.cliente.atributos || []).forEach(attr => {
            Object.keys((attr && attr.valor) || {}).forEach(key => {
              attr.valor[key] = attr.valor[key].replace(/T\d{2}:\d{2}:\d{2}.\d{3}Z/g, '');
            });
          });
          CustomModal.open({
            title: 'Atributos del Cliente',
            size: 'lg',
            templateUrl: viewAtributosTemplate,
            vm: this,
            atributos: item.orden.cliente.atributos.filter(a => a.tipo.mostrarEnTableroEspecialistas),
            ok: function() {}
          });
        }
      }
    ]
  };

  if (staticFilter) {
    this.options.staticFilter = staticFilter.and(
      Filter.path('estadoDetalle.value').eq('No iniciado').or(Filter.path('estadoDetalle.value').eq('En proceso'))
    );
    this.optionsProducto.staticFilter = Filter.path('cabecera.cliente.id').eq($stateParams.cid).and(
      Filter.path('cabecera.estado.value').eq('En proceso')
    );
  }

  function mapDetallesTerminar(servicio) {
    return $q(function(resolve, reject) {
      $ngRedux.dispatch(rest.actions.insumosControlados({ id: servicio.id }, {
        body: JSON.stringify({})
      }, (err, data) => {
        if (!err) {
          resolve(mapDetalles(servicio, data));
        } else if (err) {
          ngNotify.set(err.message, 'warn');
          reject(err);
        }
      }));
    });
  }

  function mapDetalles(servicio, productosControlados) {
    let obligatorios = {};
    let adicionales = {};
    let mapDetalles = {
      adicionales: {
        tipo: {
          orden: null,
          adicional: { nombre: 'Otros Adicionales' },
          otros: true
        },
        detalles: [],
        open: true
      }
    };
    if (servicio.precio) {
      let detalles = productosControlados.concat(servicio.precio.detalles);
      detalles.forEach(function(element) {
        if (element.tipoProductoAdicional.obligatorio) {
          obligatorios[element.tipoProductoAdicional.adicional.id] = element.tipoProductoAdicional.adicional;
        }
        adicionales[element.id] = element;

        if (element.adicional) {
          let mapDetalle = mapDetalles[element.tipoProductoAdicional.id] || {
            tipo: element.tipoProductoAdicional,
            orden: element.tipoProductoAdicional.orden,
            detalles: []
          };
          mapDetalle.detalles.push(element);
          mapDetalles[element.tipoProductoAdicional.id] = mapDetalle;
        } else {
          mapDetalles.adicionales.detalles.push(element);
        }
      });
    }

    let list = [];
    Object.keys(mapDetalles).forEach(function(key) {
      let detalle = mapDetalles[key];
      detalle.detalles = detalle.detalles.filter((v) => v.tipoProductoAdicional.adicional.activo).sort(sortAdicionalesServicio);
      list.push(detalle);
    });

    // Filtrar p/ mostrar solo los tipos de adicional con al menos un detalle
    list = list.filter((e)=>{
      return e.detalles && e.detalles.length > 0;
    });

    return { list, obligatorios, adicionales };
  }

  function canAsignar(data) {
    return this.cliente; //&& (data.estadoDetalle.value === 'No iniciado');
  }

  function canIniciar(data) {
    return this.especialista && (data.estadoDetalle.value === 'No iniciado');
  }

  function canTerminar(data) {
    return this.especialista && (data.estadoDetalle.value === 'En proceso');
  }

  this.fullscreen = () => { $timeout(() => fullscreen()); };
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);

  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.especialistasDisponiblesServicio.reset());
    unsubscribe();
  };

  const categoriaFilter = Filter.path('clase.value').eq('Servicio').or(Filter.path('clase.value').eq('Producto'));
  const configuracionConfirmarAdicional = Filter.path('codigo').eq('confirmar_adicional');

  this.$onInit = () => {
  
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    this.canCreateAtributoCliente = AuthorizationService.hasPermission('create_atributo_cliente');

    if ($stateParams.eid) {
      this.formEdit('empleados', $stateParams.eid);
    } else if ($stateParams.cid) {
      this.formEdit('clientes', $stateParams.cid);
    } else {
      $state.go('tablero-clientes', {});
    }

    $ngRedux.dispatch(rest.actions.categoriasProductos({ filter: JSON.stringify(categoriaFilter) }));
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(configuracionConfirmarAdicional) }));
  };

  function mapStateToThis(state) {
    let self = this;
    this.handleStatus(state);
    this.model = state.form.model;

    if (!state.especialistasDisponiblesServicio.loading && /*self.localModel.modalOpen &&*/ state.especialistasDisponiblesServicio.data &&
      state.especialistasDisponiblesServicio.data.data && state.especialistasDisponiblesServicio.data.data.length > 0) {
      let especialistas = [];

      state.especialistasDisponiblesServicio.data.data.forEach(function(especialista) {
        especialistas[especialista.id] = especialista;
      });
      self.loadingEspecialistas = false;
      self.sinResultadosEspecialistas = false;
      self.localModel.especialistas = especialistas;
    }

    if (state.especialistasDisponiblesServicio.data && state.especialistasDisponiblesServicio.data.length === 0) {
      self.loadingEspecialistas = false;
      self.sinResultadosEspecialistas = true;
    }

    if (state.parametros.data && state.parametros.data.length === 1) {
      let parametro = state.parametros.data[0];
      if (parametro && parametro.valor.value === 'SI') {
        self.confirmarAdicionales = true;
      } else {
        self.confirmarAdicionales = false;
      }
    }
    return {
      form: state.form,
      categorias: state.categoriasProductos.data.filter((v) => v.clase.value === 'Servicio'),
      categoriasProducto: state.categoriasProductos.data.filter((v) => v.clase.value === 'Producto')
    };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.optionsProducto.reloadData();
      this.form();
    }
  }

  function renderEspecialista(empleado) {
    return `<div class="especialista-orden">${empleado.nombre} ${empleado.apellido} </div>`;
  }

  this.renderEspecialistaModal = renderEspecialistaModal.bind(this);

  function renderEspecialistaModal(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  this.renderOrdenModal = renderOrdenModal.bind(this);

  function renderOrdenModal(orden) {
    return `${orden.numero}`;
  }

  this.loadEspecialistas = loadEspecialistas.bind(this);

  function loadEspecialistas(query, detalle) {

    this.especialistasFilter = {};

    let filter = Filter.path('activo').eq(true);

    if (query) {
      let queries = query.split(' ');
      queries.forEach((query) => {
        if (query.length) {
          filter = filter.and(Filter.path('nombre').like(query)
            .or(Filter.path('apellido').like(query)));
        }
      });
    }

    // Ordenamiento de empleados para que aparezcan los de tipo 'Normal', antes que 'Especialista'
    let sorting = {
      sortingConditions: [
        {
          path: 'tipoEmpleado.value',
          sortingType: 'desc'
        }
      ]
    };

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting) }) : BasicFactory.all();
  }

  this.loadVendedores = loadVendedores.bind(this);
  function loadVendedores(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadServicios = loadServicios.bind(this);

  function loadServicios(query) {
    if (!this.localModel.terminar) return;
    let filter = Filter.path('servicioPadre.id').eq(this.localModel.terminar.itemPadre.servicio.id);
    filter = filter.and(Filter.path('estado.value').eq('Activo'));
    filter = filter.and(Filter.path('categoria.clase.value').eq('Servicio'));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.filterAdicional = filterAdicional.bind(this);

  function filterAdicional(value) {
    if (!this.localModel.search) {
      return true;
    } else if (value.adicional) {
      return compare(value.adicional.nombre, this.localModel.search);
    } else {
      return compare(value.tipoProductoAdicional.adicional.nombre, this.localModel.search);
    }
  }


  this.loadServiciosAgregar = loadServiciosAgregar.bind(this);
  function loadServiciosAgregar(query) {
    if (!this.localModel.payload.categoria) {
      return;
    }
    let filter = Filter.path('categoria.id').eq(this.localModel.payload.categoria.id)
    .and(Filter.path('activo').eq(true))
    .and(Filter.path('estado.value').eq('Activo'))
    .and(Filter.path('servicioPadre.id').isNull());

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }


  this.filterServicioAgregar = filterServicioAgregar.bind(this);
  function filterServicioAgregar(servicio) {
    return servicio.precio;
  }

  this.loadProductosAgregar = loadProductosAgregar.bind(this);
  function loadProductosAgregar(query) {

    if (!this.localModel.terminar.nuevoDetalleProducto.categoria || !query) {
      return;
    }

    let filter = Filter.path('categoria.id').eq(this.localModel.terminar.nuevoDetalleProducto.categoria.id);

    filter = filter.and(
      Filter.path('nombre').like(query)
      .or(Filter.path('codigoBarra').like(query))
      .or(Filter.path('codigo').like(query))
    );

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.loadProductosAgregarSinOrden = loadProductosAgregarSinOrden.bind(this);

  function loadProductosAgregarSinOrden(query) {

    if (!query) {
      return;
    }

    let filter = Filter.path('categoria.id').eq(this.localModel.payload.categoria.id)
      .and(Filter.path('estado.value').eq('Activo'));

    filter = filter.and(
      Filter.path('nombre').like(query)
      .or(Filter.path('codigoBarra').like(query))
      .or(Filter.path('codigo').like(query))
    );

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }


  this.filterPadres = filterPadres.bind(this);

  function filterPadres(servicio) {
    return servicio.precio;
  }

  this.selectCategoria = selectCategoria.bind(this);

  function selectCategoria() {
    this.localModel.payload.servicio = undefined;
  }


  this.onSelectHijo = onSelectHijo.bind(this);

  function onSelectHijo() {
    let hijo = this.localModel.terminar.hijo;

    this.localModel.terminar.tieneAdicionales = hijo.detalles && hijo.detalles.length;

    if (!hijo) {
      hijo = this.localModel.terminar.itemPadre.servicio;
    }

    this.localModel.payload = {
      adicionales: {},
      usoInsumo: {}
    };

    let self = this;

    mapDetallesTerminar(hijo).then(function(value) {
      let { list, obligatorios, adicionales } = value;

      self.localModel.terminar.servicio = hijo;
      self.localModel.terminar.nuevoDetalleProducto = { cantidad : 1, categoria: hijo.conProductoCategoria };
      self.localModel.terminar.list = list;
      self.localModel.terminar.listProductos = [];
      self.localModel.terminar.obligatorios = obligatorios;
      self.localModel.terminar.adicionales = adicionales;
    });

  }

  this.agregarServicio = agregarServicio.bind(this);

  function agregarServicio() {
    let self = this;
    this.localModel.payload = {};
    let options = {
      title: 'Agregar Servicio',
      vm: self,
      size: 'lg',
      templateUrl: agregarTemplate,
      cliente: this.model,
      payload: this.localModel.payload,
      messageClass: 'font-large',
      headerClass: 'font-large',
      ok: function() {
        options.scope.$$childHead.formAsignar.especialista.$setTouched();
        if (!self.localModel.payload.especialista) {
          return false;
        }

        if (!options.scope.$$childHead.formAsignar.servicio) {
          self.ngNotify.set(self.translations['Seleccione un servicio'], 'warn');
          return false;
        }

        options.scope.$$childHead.formAsignar.servicio.$setTouched();
        if (!self.localModel.payload.servicio) {
          return false;
        }


        options.scope.$$childHead.formAsignar.pin.$setTouched();
        if (!self.localModel.payload.pin) {
          return false;
        }

        let payload = {
          servicioId: self.localModel.payload.servicio.id,
          empleadoId: self.localModel.payload.especialista.id,
          pin: self.localModel.payload.pin
        };

        $ngRedux.dispatch(rest.actions.agregarDetalleOrden({ id: self.localModel.payload.orden.id }, {
          body: JSON.stringify(payload)
        }, (err, data) => {
          if (!err) {
            ngNotify.set(self.translations['Servicio Agregado Correctamente'], 'success');
            self.options.reloadData();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    };

    $ngRedux.dispatch(rest.actions.abiertasClientes({}, {
      body: JSON.stringify({ clienteId: $stateParams.cid })
    }, (err, data) => {
      if (!err) {
        options.ordenes = data;
        CustomModal.open(options);
        self.localModel.payload.orden = data[0];
        $timeout(function() {
          $scope.$broadcast('init');
        }, 2500);
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }

  this.agregarProducto = agregarProducto.bind(this);

  function agregarProducto() {
    let self = this;
    this.localModel.payload = {
      cantidad: 1
    };
    let options = {
      title: 'Agregar Producto',
      vm: self,
      size: 'lg',
      producto: true,
      templateUrl: agregarTemplate,
      cliente: this.model,
      payload: this.localModel.payload,
      messageClass: 'font-large',
      headerClass: 'font-large',
      ok: function() {
        let conComision = true;

        if (options.scope.$$childHead.formAsignar.especialista) {
          options.scope.$$childHead.formAsignar.especialista.$setTouched();
          if (!self.localModel.payload.especialista) {
            self.ngNotify.set(self.translations['Seleccione un vendedor'], 'warn');
            return false;
          }
        } else {
          conComision = false;
        }

        if (!options.scope.$$childHead.formAsignar.servicio) {
          self.ngNotify.set(self.translations['Seleccione un producto'], 'warn');
          return false;
        }

        options.scope.$$childHead.formAsignar.servicio.$setTouched();
        if (!self.localModel.payload.servicio) {
          return false;
        }

        let payload = {
          productoId: self.localModel.payload.servicio.id,
          cantidad: self.localModel.payload.cantidad
        };

        if (conComision) {
          options.scope.$$childHead.formAsignar.pin.$setTouched();
          if (!self.localModel.payload.pin) {
            return false;
          }
          payload.empleadoId = self.localModel.payload.especialista.id
          payload.pin = self.localModel.payload.pin;
        }

        $ngRedux.dispatch(rest.actions.agregarDetalleProductoOrden({ id: self.localModel.payload.orden.id }, {
          body: JSON.stringify(payload)
        }, (err, data) => {
          if (!err) {
            ngNotify.set(self.translations['Producto Agregado Correctamente'], 'success');
            self.optionsProducto.reloadData();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    };

    $ngRedux.dispatch(rest.actions.abiertasClientes({}, {
      body: JSON.stringify({ clienteId: $stateParams.cid })
    }, (err, data) => {
      if (!err) {
        options.ordenes = data;
        CustomModal.open(options);
        self.localModel.payload.orden = data[0];
        $timeout(function() {
          $scope.$broadcast('init');
        }, 2500);
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }


  this.onSelectServicio = onSelectServicio.bind(this);
  function onSelectServicio() {
    this.localModel.payload.especialista = null;
    let servicioId = this.localModel.payload.servicio.id;
    $ngRedux.dispatch(rest.actions.especialistasDisponiblesServicio({}, {
      body: JSON.stringify({day: moment().format('DD/MM/YYYY'), servicioId})
    }));
  }

  this.loadEspecialistas = loadEspecialistas.bind(this);
  function loadEspecialistas(query) {
    let especialidades = [];
    let servicio = this.localModel.payload.servicio;
    if (servicio) {
      servicio.especialidades.forEach(function(especialidad) {
        especialidades.push(especialidad.id);
      });
    } else {
      return;
    }

    let filter = Filter.path('tipoEmpleado.value').eq('Especialista').and(Filter.path('activo').eq(true))
      .and(Filter.path('especialidades.id').in(especialidades));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadVendedores = loadVendedores.bind(this);
  function loadVendedores(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.loadTipoAtributo = loadTipoAtributo.bind(this);
  this.loadAtributo = loadAtributo.bind(this);
  this.filterAtributo = filterAtributo.bind(this);
  this.nuevoAtributoCliente = nuevoAtributoCliente.bind(this);
  this.renderTipoAtributo = renderTipoAtributo.bind(this);
  this.renderAtributo = renderAtributo.bind(this);
  this.renderCliente = renderCliente.bind(this);

  function nuevoAtributoCliente(cliente) {
    let self = this;
    CustomModal.open({
      title: 'Nuevo Atributo de Cliente',
      size: 'lg',
      templateUrl: nuevoAtributoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: {cliente: cliente, origen: 'TABLERO_ESPECIALISTA'},
      ok: function() {
        const campos = (this.payload.tipo && this.payload.tipo.campos) || [];
        const valor = this.payload.valor ||{};
        const camposRequeridosCompletados = campos
          .filter(c => c.requiredTableroEspecialista)
          .map(c => c.text)
          .reduce((camposRequeridosCompletados, campoRequerido) => {
            return camposRequeridosCompletados && valor[campoRequerido];
          }, true);

        if (!camposRequeridosCompletados) {
          ngNotify.set('Campos requeridos faltantes', 'warn');
          return false;
        }

        $ngRedux.dispatch(rest.actions.atributosClientes({}, { body: JSON.stringify(this.payload) },
          (err, data) => {
            if (!err && data) {
              ngNotify.set(self.translations['Nuevo Atributo de Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function loadTipoAtributo(query) {
    if (query) {
      var filter = Filter.path('nombre').like(query);
      filter = filter.or(Filter.path('abreviatura').like(query));
    }
    BasicFactory.setup('tipos-atributos-cliente');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  /**
   * La primera vez trae todos los atributos del cliente del backend, y los memoiza para siguientes llamadas.
   * En ambos casos, asigna a cada elemento el query, para poder ser utilizado en la funcion de filtrado, localmente.
   * Ademas convierte las fechas de string a date, para ser utilizadas por el input de fechas.
   * @param query Busqueda de atributos realizada por el usuario, aplicada sobre la concatenacion de todos los key-value
   * del atributo, de forma case insensitive.
   * @returns {*|Promise<{data: *}>}
   */
  function loadAtributo(query, modal) {
    const self = this;
    let filter = Filter.path('cliente.id').eq(this.localModel.terminar.itemPadre.orden.cliente.id);
    BasicFactory.setup('atributos-cliente');
    return !this.localModel.atributos ? BasicFactory.all({ filter: JSON.stringify(filter) }).then(response => {
      (response.data || []).forEach(attr => {
        // Guardar el query para usarlo en el filter local
        attr.query = query;
        attr.modal = modal;
        // Convertir los campos de fecha (representados como string) a objeto Date
        Object.keys((attr && attr.valor) || {}).forEach(key => {
          if (attr.valor[key].match(/.+T\d{2}:\d{2}:\d{2}.\d{3}Z/g)) {
            attr.valor[key] = new Date(attr.valor[key]);
          }
        });
      });
      self.localModel.atributos = response.data;
      return response;
    }) : Promise.resolve({
      data: self.localModel.atributos.map(attr => {
        attr.query = query;
        return attr;
      })
    });
  }

  function filterAtributo(attr) {
    const queryMatches = !(attr && attr.query) || renderAtributo(attr).toLowerCase().includes(attr.query.toLowerCase());
    const tipoMatches = !(attr
      && attr.modal
      && attr.modal.payloadAtributo
      && attr.modal.payloadAtributo.tipo
      && attr.modal.payloadAtributo.tipo.id)
      || attr.tipo.id === attr.modal.payloadAtributo.tipo.id;

    return queryMatches && tipoMatches;
  }

  this.onSelectTipoAtributo = onSelectTipoAtributo.bind(this);
  function onSelectTipoAtributo(modal) {
    modal.payloadAtributo = {cliente: modal.payloadAtributo.cliente, tipo: modal.payloadAtributo.tipo};
    this.localModel.atributos = null;
  }

  function renderTipoAtributo(tipo) {
    let detalle = tipo.abreviatura ? `<small><strong>(${tipo.abreviatura})</strong></small>` : '';
    return `${tipo.nombre} ${detalle}`;
  }

  function renderAtributo(atributo) {
    return atributo && atributo.valor && Object.keys(atributo.valor).map(key => `${key}: ${atributo.valor[key]}`).join(', ');
  }

  function renderCliente(cliente) {
    let detalle = cliente.numeroDocumento ? `<small><strong>(${cliente.numeroDocumento})</strong></small>` : '';
    return `${cliente.razonSocial} ${detalle}`;
  }

  this.guardarNuevoAtributoCliente = guardarNuevoAtributoCliente.bind(this);
  function guardarNuevoAtributoCliente(payload, options) {
    delete payload.modal;
    payload.origen = 'TABLERO_ESPECIALISTA';
    if (payload.id) {
      $ngRedux.dispatch(rest.actions.atributosClientesUpdate({id: payload.id}, { body: JSON.stringify(payload) },
        (err, data) => {
          if (!err && data) {
            payload.valor = undefined;
            payload.tipo = {abreviatura: '', nombre: ''};
            ngNotify.set(this.translations['Atributo de Cliente Actualizado'], 'success');
            options.reloadData();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
    } else {
      $ngRedux.dispatch(rest.actions.atributosClientes({}, { body: JSON.stringify(payload) },
        (err, data) => {
          if (!err && data) {
            payload.valor = undefined;
            payload.tipo = {abreviatura: '', nombre: ''};
            ngNotify.set(this.translations['Nuevo Atributo de Cliente Creado'], 'success');
            options.reloadData();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
    }
  }

  this.selectModo = selectModo.bind(this);
  function selectModo(modal) {
    modal.payloadAtributo = {cliente: modal.payloadAtributo.cliente, tipo: modal.payloadAtributo.tipo};
  }

}



// WEBPACK FOOTER //
// ./src/components/ordenes/detalles/ordenes-detalle.component.js